import React, { useState } from 'react';
import './login.css';
import signin from '../../images/signin.png';
import { FaEnvelope } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { socials, footers } from '../../data'
import logo from '../../images/logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import PageNavbar from '../../components/navbar/Navbar';
import { Container, Col, Row, Form, Button} from 'react-bootstrap';


const JobseekerLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(email, password); // log user input values
  };

  return (
    <div>
      <PageNavbar/>
      <Container fluid style={{background: '#FFA15E8C'}} className='p-0 m-0'>
        <Row>
          <Col md={6}>
          <img src={signin} alt='image of fingers on keyboard' style={{width: '100%', height:'100%'}}className=''/>
          </Col>
          <Col md={6} className='px-5 justify-content-center align-items-center'>
            <div className='px-2 px-md-5'>
            <h2 className='login-head mt-5 text-center'> Sign In</h2>
            <p className='login-text mt-5 mx-md-4 text-center'>Welcome back! Sign in to get unlimited features of Jobbers Lens</p>

            <Form className='mt-5'> 
             <Form.Group className="mb-4" controlId="formBasicEmail">
               <Form.Label className='label-form mb-2'>Email address:</Form.Label>
               <div className='input-box'>
               < FaEnvelope className='input-box-icon' />
                <Form.Control type="email" placeholder="alexjohn@gmail.com" value={email} onChange={(e) => setEmail(e.target.value)} className='input-box-container p-2 ps-5'/>
                </div>
            </Form.Group>

            <Form.Group className="mb-4" controlId="formBasicPassword">
              <Form.Label className='label-form mb-2'>Password:</Form.Label>
              <div className='input-box'>
              <FaLock className='input-box-icon' />
              <Form.Control type="password" placeholder="********" value={password} onChange={(e) => setPassword(e.target.value)}className='input-box-container p-2 ps-5'/>
              </div>
            </Form.Group>
            <Button onClick={() => navigate('/dashboard')}type="submit" className='login-btn py-3' style={{width:'100%'}}>
              Sign in
           </Button>
           <div className='d-flex mt-1 align-items-center justify-content-between '>
            
           <p>Are you an Employer? Sign in <Link to='/employerlogin'><span>here</span></Link></p>
           <a href='#' className='reset' >Reset Password</a>
           </div>
          </Form>
          <div className='text-center mt-5 login-last'>
          <p className='login-last-p'>New to Jobbers Lens? &nbsp;  
            <Link to="/jobseekersignup">Create an account now</Link>
          </p>
          <p className='login-last-p1 mt-1'>By signing in to your account,you agree to Jobbers Lens &nbsp;
            <a href='#'>Terms and Conditions</a> and &nbsp;
            <a href='#'>Privacy Policy</a>
          </p>
          </div>
          </div>
          </Col>
        </Row>

      </Container>
   
    
      
    </div>

  
  );
};

export default JobseekerLogin;

